import { Directive, ElementRef, Input, HostListener } from '@angular/core';
import { WindowRef } from '../../core/window.service';

@Directive({
    selector: '[myStickSubNav]'
})
export class StickSubNavDirective {

    /*Sticks the sub-navigation to the top of the window
    when the user scrolls past the global nav
    (which is then hidden via another directive).*/

    // Set Variables for default height and class name
    private minY: number = 80;
    private classNameStick: string = 'stick';

    //The ability to change the min # via a [input]
    @Input('stickMin') set stickMin(minY: number) {
        this.minY = minY || this.minY;
    }

    //The ability to change the class name via a [input]
    @Input('stickClass') set stickClass(className: string) {
        this.classNameStick = className || this.classNameStick;
    }

    constructor(private el: ElementRef, private window: WindowRef) {

    }

    @HostListener('window:scroll', ['$event'])
    handleScrollEvent(e) {

        //If window offset is greater than minY, set class on sub nav
        if (this.window.nativeWindow.pageYOffset > this.minY) {
            this.el.nativeElement.classList.add(this.classNameStick);
        } else {
            //remove class from sub nav
            this.el.nativeElement.classList.remove(this.classNameStick);
        }
    }
}
